<template>
  <AutoComplete
    :model-value="modelValue"
    search-url="/api/v1/organizations/autocomplete/"
    :placeholder="placeholder"
    :label="label"
    :disabled="disabled"
    :min-chars="3"
    @update:model-value="$emit('update:modelValue', $event)"
  />
</template>

<script setup>
import AutoComplete from '@/components/shared/AutoComplete.vue'

defineProps({
  modelValue: {
    type: Object,
    default: null,
  },
  placeholder: {
    type: String,
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

defineEmits(['update:modelValue'])
</script>
